import { styled } from '@mui/system';
import { tucarBlue, realWhite, tucarRed } from 'Themes';

export const StandardErrorButtonStyle = styled('button')`
  font-family: Poppins, sans-serif;
  font-weight: 400;
  background-color: ${realWhite};
  color: ${tucarRed};
  transition: all 150ms ease;
  cursor: pointer;
  border: 2px solid ${tucarRed};
  border-radius: 25px;
  line-height: 100%;
  text-transform: none;
  &:hover {
    background-color: ${tucarRed};
    font-family: PoppinsSemiBold;
    color: ${realWhite};
  }
  &:disabled {
    cursor: not-allowed;
    pointer-events: auto;
    color: ${tucarRed};
    font-family: PoppinsRegular;
    opacity: 0.3;
  }
  &:disabled:hover {
    background-color: ${realWhite};
    opacity: 0.3;
    color: ${tucarRed};
    font-family: PoppinsRegular;
    text-transform: none;
  }
`;

export const StandardButtonStyle = styled('button')`
  font-family: Poppins, sans-serif;
  font-weight: 400;
  background-color: ${realWhite};
  color: ${tucarBlue};
  transition: all 150ms ease;
  cursor: pointer;
  border: 2px solid ${tucarBlue};
  border-radius: 25px;
  line-height: 100%;
  text-transform: none;
  &:hover {
    background-color: ${tucarBlue};
    font-family: PoppinsSemiBold;
    color: ${realWhite};
  }
  &:disabled {
    cursor: not-allowed;
    pointer-events: auto;
    color: ${tucarBlue};
    font-family: PoppinsRegular;
    opacity: 0.3;
  }
  &:disabled:hover {
    background-color: ${realWhite};
    opacity: 0.3;
    color: ${tucarBlue};
    font-family: PoppinsRegular;
    text-transform: none;
  }
`;

export const StaticStandardButtonStyle = styled('button')`
  font-family: Poppins, sans-serif;
  font-weight: 400;
  background-color: ${realWhite};
  color: ${tucarBlue};
  transition: all 150ms ease;
  cursor: pointer;
  border: 2px solid ${tucarBlue};
  border-radius: 25px;
  line-height: 100%;
  text-transform: none;
  &:disabled {
    cursor: not-allowed;
    pointer-events: auto;
    color: ${tucarBlue};
    font-family: PoppinsRegular;
    opacity: 0.3;
  }
`;
